import { INJECTOR } from "@angular/core";

export const APP_CONSTANTS = {
  USER_ROLES : {
      OWNER : "owner",
      TENANT : "tenant",
      SUPER_ADMIN : "super_admin",
      PARTER_ADMIN : "partner_admin",
      PROPERTY_MANAGER : "property_manager",
      MAINTENANCE_MANAGER : "maintance_manager",
      TELE_CALLER : "tele_caller",
      VENDOR : "vendor"
  },
  PAYMENT_KEY : "rzp_test_NtFfNNWaRJiCCq"
}
export const USER_PERMISSIONS =  {
    USERS : {
      USERS_PAGE : "users_page",
      CREATE_USER : "create_user",
      UPDATE_USER : "update_user",
      DELETE_USER : "delete_user"
    },
    PERMISSIONS : {
      PERMISSIONS_PAGE : "permissions_page",
      VIEW_PERMISSIONS : "view_permissions",
      UPDATE_PERMISSIONS : "update_permissions"
    },
    OWNERS : {
      OWNERS_PAGE : "owners_page",
      OWNERS_VIEW : "owners_view",
      OWNERS_DELETE : "owners_delete",
      OWNERS_ADD : "owner_add",
      OWNERS_UPDATE : "owners_edit"
    },
    TENANTS : {
      TENANTS_PAGE : "tenants_page",
      TENANTS_DELETE : "tenants_delete",
      TENANTS_ADD : "tenant_add",
      TENANTS_UPDATE : "tenants_update"
    },
    USER_INFO : {
      USER_INFO_TAB : "user_info_tab",
      USER_DOCUMENTS_TAB : "user_documents_tab",
      USER_BILLS_TAB : "user_bills_tab",
      USER_LEASE_TAB : "user_lease_tab",
      USER_BANK_TAB : "user_bank_tab",
      USER_LOCAL_TAB : "user_local_tab",
      USER_PERSONAL_UPDATE : "user_personal_update",
      USER_ADDRESS_UPDATE : "user_address_update",
      USER_WORK_VIEW : "user_work_view",
      USER_WORK_UPDATE : "user_work_update",
      USER_BANK_ADD : "user_bank_add",
      USER_BANK_UPDATE : "user_bank_update",
      USER_LOCAL_ADD : "user_local_add",
      USER_LOCAL_UPDATE : "user_local_update"
    },
    PROPERTIES : {
      PROPERTIES_PAGE : "properties_page",
      PROPERTY_ADD : "property_add",
      PROPERTY_VIEW : "property_view",
      PROPERTY_MANAGED_BY_FILTER: "property_managed_by_filter",
      PROPERTY_DETAILS_TAB : "property_details_tab",
      PROPERTY_ROOMS_TAB : "property_rooms_tab",
      PROPERTY_AMENITIES_TAB : "property_amenities_tab",
      PROPERTY_IMAGES_TAB : "property_images_tab",
      PROPERTY_BILLS_TAB : "property_bills_tab",
      PROPERTY_DOCUMENTS_TAB : "property_documents_tab",
      PROPERTY_LEASES_TAB : "property_leases_tab",
      PROPERTY_ENQUIRIES_TAB : "property_enquiries_tab",
      PROPERTY_EDIT : "property_edit",
      ADD_BILL : "add_bill",
      VIEW_BILL : "view_bill",
      EDIT_BILL : "edit_bill",
      DELETE_BILL : "delete_bill",
      VIEW_BILL_COPY : "view_bill_copy",
      GENERATE_INVOICE : "generate_invoice",
      REGENERATE_INVOICE : "regenerate_bill_pdf",
      VIEW_INVOICE : "view_invoice",
      ADD_DOCUMENT : "add_document",
      VIEW_DOCUMENT : "view_document",
      DELETE_DOCUMENT : "delete_document",
      PROPERTY_BUYER_DETAILS_TAB : "property_buyer_details_tab",
      ADD_BUYER_DETAILS : "add_buyer_details",
      EDIT_BUYER_DETAILS : "edit_buyer_details",
      DELETE_BUYER_DETAILS : "delete_buyer_details",
      VIEW_BUYER_DETAILS : "view_buyer_details",
      ADD_LEASE : "add_lease",
      ARCHIVE_LEASE : "archive_lease",
      PREVIOUS_LEASES : "previous_leases",
      VIEW_LEASE : "view_lease",
      EDIT_LEASE : "edit_lease",
      RENEW_LEASE : "renew_lease",
      ADD_PROPERTY_IMAGES : "add_property_images",
      DELETE_PROPERTY_IMAGES : "delete_property_images",
      UPDATE_PROPERTY_IMAGES_LISTING : "update_property_image_listing",
    },
    INSPECTIONS : {
      INSPECTION_PAGE : "inspection_page",
      INSPECTION_ADD : "inspection_add",
      INSPECTION_EDIT : "inspection_edit",
      INSPECTION_START : "inspection_start",
      INSPECTION_ADD_ROOM : "inspection_add_rooms",
      INSPECTION_ADD_ROOM_ITEMS : "inspection_add_room_items",
      INSPECTION_DELETE_ROOM : "inspection_delete_rooms",
      INSPECTION_DELETE : "inspection_delete",
      INSPECTION_REPORT_VIEW :"inspection_report_view",
      INSPECTION_DOWNLOAD : "inspection_pdf_download",
      INSPECTION_VIEW_LOCATION : "inspection_view_location"
    },
    SERVICE_REQUEST : {
      SERVICE_REQUEST_PAGE : "service_request_page",
      SERVICE_REQUEST_ADD : "service_request_add",
      SERVICE_REQUEST_EDIT : "service_request_edit",
      SERVICE_REQUEST_DELETE : "service_request_delete"
    },
    REPORTS: {
      REPORTS_PAGE: "reports_page",
      REPORTS_OWNER_PAGE: "reports_owner_page",
      REPORTS_COMPANY_PAGE: "reports_company_page",
      REPORTS_DOWNLOAD: "reports_download",
      REPORTS_MAIL: "reports_mail",
      REPORTS_INSPECTION_PAGE: "report_inspection",
      REPORTS_PROPERTIES_PAGE: "report_property",
      REPORTS_LEASES_PAGE: "report_lease",
      REPORTS_SERVICE_REQUESTS_PAGE: "reports_service_requests_page",
      REPORTS_LEADS_PAGE: "report_lead",
      REPORTS_ENQUIRIES_PAGE: "report_enquiry",
      REPORTS_ACCOUNTS_PAGE: "report_account"
    },
    NOTIFICATIONS : {
      "NOTIFICATIONS_PAGE" : "notifications_page"
    },
    BILL_CATEGORIES : {
      BILL_CATEGORIES_PAGE : "bill_categories_page"
    },
    ITEMS : {
      ITEMS_PAGE : "items_page",
      ADD_ITEM : "add_item",
      EDIT_ITEM : "edit_item",
      DELETE_ITEM : "delete_item"
    },
    ENQUIRIES : {
      ENQUIRY_PAGE : "enquiry_page",
      ENQUIRY_ADD : "enquiry_add",
      ENQUIRY_EDIT : "enquiry_edit",
      ENQUIRY_UPDATE : "enquiry_update",
      ENQUIRY_VIEW_COMMENT : "enquiry_view_comments",
      ENQUIRY_ADD_COMMENT : "enquiry_add_comment"
    },
    TEMPLATES : {
      TEMPLATES_PAGE : "templates_page"
    },
    LEADS : {
      LEADS_PAGE : "leads_page",
      LEADS_ADD : "leads_add",
      LEADS_UPDATE : "leads_update",
      LEADS_DELETE : "leads_delete",
      LEADS_ADD_COMMENTS : "leads_add_comments",
      LEADS_VIEW_COMMENTS : "leads_view_comments"
    },
    TASKS : {
      TASKS_PAGE : "tasks_page",
      TASKS_ADD : "tasks_add",
      TASKS_UPDATE : "tasks_update",
      TASKS_DELETE : "tasks_delete",
      TASKS_VIEW_COMMENTS : "tasks_view_comments",
      TASKS_ADD_COMMENTS : "tasks_add_comments",
      TASKS_ASSIGN : "tasks_assign",
      TASKS_VIEW_ALL : "tasks_view_all",
      TASKS_LOG_ACTIVITY : "tasks_log_activity",
      TASKS_MANAGE_TEMPLATES : "tasks_manage_templates",
      TASKS_REPORTS : "tasks_reports"
    },
    BANK_ACCOUNTS : {
      BANK_ACCOUNTS_PAGE : "bank_accounts_page",
      BANK_ACCOUNT_ADD : "bank_account_add",
      BANK_ACCOUNT_UPDATE : "bank_account_update",
      BANK_ACCOUNT_DELETE : "bank_account_delete"
    },
    AGENT : {
      AGENT_QUERY : "agent_query",
      AGENT_VIEW_SQL : "agent_view_sql"
    },
    ERROR_MSGS : {
      PERMISSION_NOT_FOUND : "You don't have permission to view this page"
    }
};
